"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WalletInterface = require('../interface/walletInterface');

var util = require('../util');

var Provider = require('../provider');

var Web3 = require('web3');

var ERROR = require('../constant/error');

var Metamask = /*#__PURE__*/function (_WalletInterface) {
  _inherits(Metamask, _WalletInterface);

  var _super = _createSuper(Metamask);

  function Metamask(net) {
    var _this;

    _classCallCheck(this, Metamask);

    _this = _super.call(this, net, 'softwallet');

    _defineProperty(_assertThisInitialized(_this), "setAccountByMetamask", function (callback) {
      _this.provider = window.ethereum;
      if (!_this.provider) return callback(ERROR.CANNOT_FOUND_PROVIDER, null);
      return _this.provider.request({
        method: 'net_version'
      }).then(function (netId) {
        if (util.getNetworkId(netId, 'number') != util.getNetworkId(_this.net, 'number')) return callback(ERROR.INVALID_NETWORK, null);
        return _this.provider.request({
          method: 'eth_requestAccounts'
        }).then(function (re) {
          _this.web3 = new Web3(_this.provider);
          _this.web3.killSession = _this.killSession;
          return callback(null, _this.web3);
        }).catch(function (er) {
          return callback(er, null);
        });
      }).catch(function (er) {
        return callback(er, null);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "killSession", function () {
      /* Do nothing, just for consistent API */
    });

    return _this;
  }

  return Metamask;
}(WalletInterface);

module.exports = Metamask;